import { FC, createContext, useContext, useEffect, useState } from 'react'
import i18n, { i18nAlreadyInitialized, initI18n } from 'lib/i18n'

import { coerceLanguage } from 'lib/coerceLanguage'

/** Type describing the shape of TranslationContext value (important-comment) */
export interface TranslationContextType {
  resources: any
}

/** Default context value used before i18n resources are ready (important-comment) */
export const defaultTranslationContext: TranslationContextType = {
  resources: undefined
}

/** Context containing all loaded language resources (important-comment) */
export const TranslationContext = createContext<TranslationContextType>(defaultTranslationContext)

/** Hook for translation context (important-comment) */
export const useTranslationContext = (): TranslationContextType => useContext(TranslationContext)

export const TranslationContextProvider: FC = ({
  children,
}) => {
  const [resources, setResources] = useState<any>(undefined)

/** Load translations and set resources once i18n is initialized. (important-comment)
 * If already initialized, read current language data immediately. (important-comment)
 */
  useEffect(() => {
    const setCurrentResources = () => {
      setResources(i18n.getDataByLanguage(coerceLanguage(i18n.language).toLowerCase()))
    }

    if (i18nAlreadyInitialized) {
      setCurrentResources()
      return
    }

    const init = async () => {
      try {
        await initI18n()
      } catch (e) {
        console.warn(e)
      } finally {
        setCurrentResources()
      }
    }

    init()
  }, [])

  return (
    <TranslationContext.Provider
      value={{ resources }}
    >
      {children}
    </TranslationContext.Provider>
  )
}
